export default {"src":"/_next/static/image/public/images/Ic_homecare_past.188411ff23cc04c6caa160e7d678b3c7.svg","height":40,"width":40};